import { diaSeguinte, somenteData } from "./comparativoHelpers";

export const SKU_PAGE_SIZE = 20;

const MODO_ROTULO = {
  erp: "categorias do ERP",
  ouran: "catálogo Ouran",
  misto: "mudança de classificação dentro do período",
  timeline: "linha do tempo de categorias inconsistente",
};

// Parâmetros comuns dos dois endpoints (categorias e SKUs) a partir do recorte
// aplicado no Comparativo. `search` só vai quando tem texto.
export const parametrosDaVariacao = (
  applied,
  { sortBy = "delta", order = "desc", search = "" } = {}
) => {
  const params = {
    branch_a: applied.a.branchId,
    start_a: somenteData(applied.a.startDate),
    end_a: diaSeguinte(applied.a.endDate),
    branch_b: applied.b.branchId,
    start_b: somenteData(applied.b.startDate),
    end_b: diaSeguinte(applied.b.endDate),
    tipo: applied.revenueMode,
    sort_by: sortBy,
    order,
  };
  const termo = (search || "").trim();
  if (termo) params.search = termo;
  return params;
};

// Clicar na coluna ativa inverte a direção; numa coluna nova começa do maior
// para o menor.
export const proximaOrdenacao = (atual, campo) => {
  if (atual.sortBy === campo) {
    return { sortBy: campo, order: atual.order === "desc" ? "asc" : "desc" };
  }
  return { sortBy: campo, order: "desc" };
};

export const corDaVariacao = (delta) => {
  if (delta == null || Math.abs(delta) < 0.005) return "#8c8c8c";
  return delta > 0 ? "#52c41a" : "#ff4d4f";
};

export const formatarVariacaoMoeda = (delta) => {
  if (delta == null) return "—";
  const texto = Math.abs(delta).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  if (Math.abs(delta) < 0.005) return texto;
  return `${delta > 0 ? "+" : "-"}${texto}`;
};

// Sem base no período A não existe percentual: o item é novo no recorte B.
export const formatarVariacaoPct = (pct, receitaA, receitaB) => {
  if (pct == null) return receitaA === 0 && receitaB > 0 ? "novo" : "—";
  const texto = Math.abs(pct).toLocaleString("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  if (Math.abs(pct) < 0.05) return `${texto}%`;
  return `${pct > 0 ? "+" : "-"}${texto}%`;
};

export const textoDeModosDiferentes = (meta) => {
  if (!meta || meta.comparable !== false) return null;
  const a = MODO_ROTULO[meta.mode_a] || meta.mode_a;
  const b = MODO_ROTULO[meta.mode_b] || meta.mode_b;
  return `Os dois lados usam classificações de categoria diferentes (${a} × ${b}), então as categorias não são comparáveis. Compare lojas ou períodos que usem a mesma classificação durante todo o intervalo.`;
};
